import { Globals } from "./Globals";
import { QMFARFC } from "./QMFARFC";

export class QMFAEmailSetupLink extends QMFARFC {
  constructor() {
    super();
  }

  SetParams(org, username, notifyUser) {
    this.AddParameter("user", username);
    this.AddParameter("email", Globals._wsMgr.GetUserEmail());
    this.AddParameter("org", org);
    this.AddParameter("endUser", notifyUser);
    this.AddParameter("mode", "emailMFALink");
  }

  DoTransactionComplete(response, callbackObj) {
    var r = JSON.parse(response);
    if (callbackObj) {
      callbackObj.EmailSetupLinkResult(r["success"], r["message"]);
    }
  }
}
